import React from "react";
import PointSectionView from "src/pages/section/PointSection/view";

export interface PointSectionVideoProps {
    defaultVideoSrc?: string;
    tabletVideoSrc?: string;
}

export interface PointSectionProps {
}

function PointSection(props: PointSectionProps & PointSectionVideoProps) {
    const defaultVideoSrc = "/videos/video_coin.mp4";
    const tabletVideoSrc = "/videos/video_coin_mob.mp4";


    return <PointSectionView
        {...props}
        defaultVideoSrc={defaultVideoSrc}
        tabletVideoSrc={tabletVideoSrc}
    />;
}

export default PointSection;
